<template>
  <div class="columns page-logs-tracking-event-header">
    <div class="column is-4">
      <sc-logs-tracking-lote-detail-header-lote />
    </div>
  </div>
</template>

<script>
  import { ScButton } from '@intelipost-js/secure-components';
  import ScLogsTrackingLoteDetailHeaderLote from './blocks/sc-logs-tracking-lote-detail-header-lote/ScLogsTrackingLoteDetailHeaderLote';

  export default {
    name: 'sc-logs-tracking-detail-header',
    components: {
      ScButton,
      ScLogsTrackingLoteDetailHeaderLote,
    },
  };
</script>

<style lang="scss" scoped>
  .page-logs-tracking-event-header{
    &__buttons{
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/components/sc-logs-tracking-lote-detail-header/ScLogsTrackingLoteDetailHeader.vue